<template>
  <div class="modal">
    <TitleArea
      text="クイズミッション"
      @click-close="onClickClose"
      :showReturn="true"
    />
    <div class="modal-content-area">
      <Info :selectedMission="selectedMission" />
      <div
        class="buttonArea"
        :class="{
          disabled: distance > quizMissionDistance,
        }"
        @click="onCickTry"
      >
        <div class="buttonMainArea">
          <div>挑戦する</div>
        </div>
      </div>
    </div>
    <FarDistanceCaution :distance="quizMissionDistance" />
    <!-- <LoginCaution /> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleArea from "@/components/Atoms/TitleArea";
import Info from "@/components/QuizMission/Info";
import { QUIZ_MISSION_DISTANCE } from "../../const.js";
import FarDistanceCaution from "@/components/Missions/FarDistanceCaution";
// import LoginCaution from "@/components/Missions/LoginCaution";

export default {
  name: "show-mission-area",
  components: {
    TitleArea,
    FarDistanceCaution,
    // LoginCaution,
    Info,
  },
  props: {
    distance: { type: Number, require: true },
    selectedMission: { type: Object, require: true },
  },
  computed: {
    ...mapState(["isLoggedInWithFirebaseAuth"]),
    quizMissionDistance() {
      return QUIZ_MISSION_DISTANCE;
    },
    displayDistance() {
      const n = 1;
      return Math.round(this.distance * Math.pow(10, n)) / Math.pow(10, n);
    },
  },
  methods: {
    ...mapMutations(["setModal"]),
    onClickClose() {
      this.$emit("click-close");
    },
    onCickTry() {
      if (this.isLoggedInWithFirebaseAuth === false) {
        this.setModal("signin");
        return;
      }

      // TODO
      if (this.distance > this.quizMissionDistance) {
        return;
      }
      this.$emit("click-try");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.modal {
  background-color: white;
  z-index: 3;
  transform: translateZ(3px);
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  .modal-content-area {
    padding: 2.5rem 0 3rem 0;
    height: calc(100% - 8rem);
    overflow: scroll;
  }
}
.buttonArea {
  margin: 1rem auto 0;
  border-radius: 4px;
  background: #ff7c86;
  width: calc(100% - 1.25rem);
  &.disabled {
    background: #c3c3c3;
    margin-bottom: 5rem;
  }
  .buttonMainArea {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem 0;
    color: white;
    font-size: 1.1rem;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuizMission/InfoModal.vue